<template>
    <div class="unavailable">
        <!-- 顶部栏：语言切换 -->
        <div class="top-bar">
            <mu-menu cover :open.sync="isMenuOpen">
                <mu-button flat small class="lang-btn">
                    <mu-icon value="language" style="margin-right:4px;"></mu-icon>
                    {{ getLanage() }}
                </mu-button>
                <mu-list slot="content">
                    <mu-list-item button @click="selectLanage('DK')">
                        <mu-list-item-title>DK</mu-list-item-title>
                    </mu-list-item>
                    <mu-list-item button @click="selectLanage('EN')">
                        <mu-list-item-title>EN</mu-list-item-title>
                    </mu-list-item>
                    <mu-list-item button @click="selectLanage('PT')">
                        <mu-list-item-title>PT</mu-list-item-title>
                    </mu-list-item>
                    <mu-list-item button @click="selectLanage('中文')">
                        <mu-list-item-title>中文</mu-list-item-title>
                    </mu-list-item>
                </mu-list>
            </mu-menu>
        </div>

        <div class="page-body">
            <!-- 轮播图 -->
            <div class="banner-wrap" v-if="banners.length > 0">
                <mu-carousel class="banner-carousel" :cycle="true" transition="fade">
                    <mu-carousel-item v-for="(image, index) in banners" :key="index">
                        <img :src="getImgUrl(image, 800)" class="banner-img" alt="banner" />
                    </mu-carousel-item>
                </mu-carousel>
            </div>

            <!-- 进入点单按钮 -->
            <mu-button class="enter-btn" :disabled="checking" @click="enterOrdering">
                {{ $t('unavailable.enterOrder') }}
            </mu-button>

            <!-- 提示信息（富文本） -->
            <div class="info-card" v-if="configsData.UnavailableInfoTip">
                <div class="info-content" v-html="configsData.UnavailableInfoTip"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import preventBack from 'vue-prevent-browser-back';
    export default {
        name: 'Unavailable',
        mixins: [preventBack],//注入  阻止返回上一页
        data() {
            return {
                seller: {},
                configsData: {},
                tableOrderInfo: {},
                bankTimes: [],
                isMenuOpen: false,
                checking: false,
            }
        },
        computed: {
            // UnavailableBanner：图片名称数组字符串
            banners() {
                const raw = this.configsData.UnavailableBanner;
                if (!raw) return [];
                let list = [];
                try {
                    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
                    list = Array.isArray(parsed) ? parsed : [];
                } catch (e) {
                    list = String(raw).split(',').map(item => item.trim());
                }
                return list.filter(item => {
                    if (!item) return false;
                    const name = String(item).toLowerCase();
                    return name !== 'undefined' && name.indexOf('default.png') === -1;
                });
            },
        },
        mounted() {
            this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
            this.tableOrderInfo = this.getItem('sessionStorage', 'tableOrderInfo') || {};
            if (!this.tableOrderInfo.restaurantId) {
                this.tableOrderInfo = JSON.parse(window.localStorage.getItem('tableOrderInfo') || '{}');
            }
            this.getRestaurantInfo();
            this.getConfigs();
            this.getBankTimes();
        },
        methods: {
            getRestaurantInfo() {
                if (!this.tableOrderInfo.restaurantId) return Promise.resolve();
                return this.$get('QRCodeBasicInfo/GetRestaurant', { restaurantId: this.tableOrderInfo.restaurantId })
                    .then(response => {
                        if (response.code == 200) {
                            this.seller = response.data;
                            window.localStorage.setItem('seller', JSON.stringify(this.seller));
                            this.getLanage();
                        }
                    });
            },
            getConfigs() {
                if (!this.tableOrderInfo.restaurantId) return Promise.resolve();
                return this.$get('QRCodeBasicInfo/GetConfigs', { restaurantId: this.tableOrderInfo.restaurantId })
                    .then(response => {
                        if (response.code == 200) {
                            const data = {};
                            response.data.forEach(item => {
                                data[item.configKey] = item.configValue;
                            });
                            this.configsData = data;
                        }
                    });
            },
            // 从 restaurant_bank 表拉营业时间（bankType=0）
            getBankTimes() {
                if (!this.tableOrderInfo.restaurantId) return Promise.resolve();
                return this.$get('QRCodeOrder/GetRestaurantBanById', {
                    restaurantId: this.tableOrderInfo.restaurantId,
                    bankType: 0
                }).then(response => {
                    if (response.code == 200) {
                        this.bankTimes = response.data || [];
                    }
                });
            },
            getLanage() {
                if (localStorage.getItem('lang') != undefined && localStorage.getItem('lang') != null) {
                    this.$i18n.locale = localStorage.getItem('lang');
                    return localStorage.getItem('lang');
                }
                this.$i18n.locale = this.seller.language;
                return this.seller.language;
            },
            selectLanage(lng) {
                this.$i18n.locale = lng;
                localStorage.setItem('lang', lng);
                this.isMenuOpen = false;
            },
            getImgUrl(image, w = 0) {
                if (image == undefined || image == 'undefined' || image == null || image == '') {
                    return null;
                }
                if (w == 0) {
                    return this.imageBaseUrl + image;
                }
                return this.global.baseUrl + 'api/images/' + w + '/' + image;
            },
            // 配置是否开启（值为 1 时开启）
            isConfigOn(key) {
                return String(this.configsData[key]) === '1';
            },
            // 是否在营业时间内（未配置营业时间或没匹配到当天时间段时不拦截）
            // 营业时间来自接口 GetRestaurantBanById(bankType=0) 返回的 List<RestaurantBank>
            isOpenNow() {
                if (!this.bankTimes || this.bankTimes.length === 0) return true;
                const day = new Date().getDay(); // 0=Sunday, 1=Monday ... 6=Saturday
                const entry = this.bankTimes[day];
                if (!entry) return true;
                // 后端字段可能是 BeginTime/EndTime（Pascal）或 beginTime/endTime（camel）
                const begin = entry.beginTime || entry.BeginTime;
                const end = entry.endTime || entry.EndTime;
                if (!begin || !end) return true;
                const toMinute = (time) => {
                    const arr = String(time).split(':');
                    return (parseInt(arr[0]) || 0) * 60 + (parseInt(arr[1]) || 0);
                };
                const beginMinute = toMinute(begin);
                const endMinute = toMinute(end);
                if (beginMinute === endMinute) return true;
                const now = new Date();
                const currentMinute = now.getHours() * 60 + now.getMinutes();
                if (endMinute > beginMinute) {
                    return currentMinute >= beginMinute && currentMinute < endMinute;
                }
                // 跨天营业（例如 18:00 - 02:00）
                return currentMinute >= beginMinute || currentMinute < endMinute;
            },
            // 当前桌台是否已有套餐数据
            checkPackageQuantity() {
                const param = {
                    restaurantId: this.tableOrderInfo.restaurantId,
                    tableName: this.tableOrderInfo.tableName
                };
                return this.$get('QRCodeOrder/GetOrderBuffetPackage', param)
                    .then(response => {
                        if (response.code != 200) return false;
                        const list = response.data || [];
                        return list.some(item => (parseInt(item.quantity) || 0) > 0);
                    })
                    .catch(() => false);
            },
            async enterOrdering() {
                if (this.checking) return;
                this.checking = true;
                this.tableOrderInfo = this.getItem('sessionStorage', 'tableOrderInfo') || this.tableOrderInfo;

                // 每次点击重新获取配置、餐厅信息和营业时间，保证店家临时开台或调整营业时间后能立即生效
                await this.getConfigs();
                await this.getRestaurantInfo();
                await this.getBankTimes();
                // 单点模式与套餐无关，不需要查询套餐数据
                const hasPackage = this.isConfigOn('SingleService') ? false : await this.checkPackageQuantity();

                if (this.isConfigOn('RedirectOnClosedHours') && !this.isOpenNow()) {
                    this.checking = false;
                    this.$alert(this.$t('unavailable.closedHours'), this.$t('common.alert'), {
                        okLabel: this.$t('common.ok')
                    });
                    return;
                }
                // 单点模式没有套餐概念，跳过开台（套餐数据）检查
                if (!this.isConfigOn('SingleService') && this.isConfigOn('SelfCheckIn') && !hasPackage) {
                    this.checking = false;
                    this.$alert(this.$t('unavailable.contactRestaurant'), this.$t('common.alert'), {
                        okLabel: this.$t('common.ok')
                    });
                    return;
                }

                this.checking = false;
                // 单点模式直接进 Buffet 点餐页，跳过套餐选择页（isSeft=0）
                if (this.isConfigOn('SingleService')) {
                    this.$router.push({ path: '/buffet', query: { isSeft: 0, v: 20260811 } });
                    return;
                }
                this.$router.push({ path: '/buffetSelect', query: {} });
            },
        },
    }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    .unavailable
        position: fixed
        top: 0
        bottom: 0
        width: 100%
        overflow-y: auto
        -webkit-overflow-scrolling: touch
        background: linear-gradient(160deg, #fff6f1 0%, #ffffff 55%, #fde8df 100%)

    .top-bar
        position: absolute
        top: 12px
        right: 12px
        z-index: 1000
        display: flex
        align-items: center

        .lang-btn
            min-width: auto
            padding: 0 12px
            height: 32px
            line-height: 32px
            border-radius: 16px
            font-weight: 600
            font-size: 13px
            color: #da5b3a
            background: rgba(255,255,255,0.9)
            border: 1px solid rgba(218,91,58,0.25)
            box-shadow: 0 2px 8px rgba(218,91,58,0.08)
            text-transform: none

    .page-body
        max-width: 480px
        margin: 0 auto
        padding: 64px 24px 48px
        display: flex
        flex-direction: column
        align-items: center
        box-sizing: border-box
        min-height: 100%

    .banner-wrap
        width: 100%
        margin-bottom: 28px
        border-radius: 20px
        overflow: hidden
        box-shadow: 0 8px 24px rgba(218,91,58,0.15)

    .banner-carousel
        width: 100%
        height: 300px

    .banner-img
        display: block
        width: 100%
        height: 300px
        object-fit: cover

    .enter-btn
        width: 100%
        height: 50px
        border-radius: 26px
        margin: 4px 0 28px
        background: linear-gradient(135deg, #e8733a 0%, #da5b3a 100%)
        color: #fff
        font-size: 17px
        font-weight: 600
        letter-spacing: 0.5px
        text-transform: none
        box-shadow: 0 6px 18px rgba(218,91,58,0.35)
        transition: transform .15s ease, box-shadow .15s ease
        &:active
            transform: scale(0.98)
            box-shadow: 0 3px 10px rgba(218,91,58,0.25)
        &.mu-button--disabled
            background: #d8d8d8
            box-shadow: none
            color: #fff

    .info-card
        width: 100%
        padding: 16px 18px
        background: #fff
        border-radius: 18px
        box-shadow: 0 4px 20px rgba(218,91,58,0.08)
        box-sizing: border-box

    .info-content
        font-size: 14px
        line-height: 1.7
        color: #4a4a4a
        word-break: break-word
        text-align: left

        >>> p
            margin: 0 0 10px

        >>> p:last-child
            margin-bottom: 0

        >>> img
            max-width: 100%
            height: auto
            display: block
            margin: 10px auto
            border-radius: 10px

        >>> ul,
        >>> ol
            margin: 8px 0
            padding-left: 20px

        >>> li
            margin: 4px 0

        >>> a
            color: #da5b3a
            text-decoration: underline

        >>> strong
            color: #333

        >>> h1,
        >>> h2,
        >>> h3,
        >>> h4
            margin: 8px 0
            font-size: 16px
            font-weight: 700
            color: #333
</style>



// WEBPACK FOOTER //
// src/components/Unavailable.vue